import { FC } from 'react'

import { ComponentTextModel, ListTheme } from 'api'
import { Markdown } from 'components/markdown'
import { cn } from 'utils'

import classes from './text-only.module.css'
import common from '../common.module.css'

interface TextOnlyProps {
  data: ComponentTextModel
  className?: string
}

const LIST_THEME_CLASSES: Record<ListTheme, string | undefined> = {
  [ListTheme.accentArrow]: classes.accentArrowList,
  [ListTheme.checkmark]: classes.checkmarkList,
}

export const TextOnly: FC<TextOnlyProps> = ({ data, className }) => {
  return (
    <Markdown
      className={cn(
        classes.markdown,
        data.with_border && common.withBorder,
        data.list_theme && LIST_THEME_CLASSES[data.list_theme],
        className,
      )}
    >
      {data.text}
    </Markdown>
  )
}
